<template>
  <div class="integralGift">
    <div class="integral_total">
      <router-link :to="`/integral/detail?shopId=${shopId}`">
        <img src="../images/gift_back.png" alt="">
      </router-link>
      <p class="white f20_rem mar20_b">{{shopPoints.pointsName}}转赠</p>
      <span>多种玩法选择赠送{{shopPoints.pointsName}}乐呵呵</span>
    </div>
    <div class="gift_type">
      <span :class="{gift_type_active:pointsGive.giveType === '1'}" @click="switchGiveType('1')">普通包</span>
      <span :class="{gift_type_active:pointsGive.giveType === '3'}" @click="switchGiveType('3')">专属包</span>
    </div>
    <ul class="b_white">
      <template v-if="pointsGive.giveType === '1'">
        <li>
          <div class="w25 fb t_right">赠送个数</div>
          <input v-model="pointsGive.giveCount" @input="pointsGive.giveCount=formatNums(pointsGive.giveCount,0)" placeholder="填写个数" class="flex_1" type="text" />
          <span class="fb">个</span>
        </li>
        <li>
          <div class="w25 fb t_right">单个积分</div>
          <input v-model="pointsGive.singlePoints" @input="pointsGive.singlePoints=formatNums(pointsGive.singlePoints,2)" placeholder="0.00" class="flex_1" type="text" />
          <span class="fb">{{shopPoints.pointsName}}</span>
        </li>
      </template>
      <template v-if="pointsGive.giveType === '2'">
        <li>
          <div class="w25 fb t_right">赠送个数</div>
          <input v-model="pointsGive.giveCount" @input="pointsGive.giveCount=formatNums(pointsGive.giveCount,0)" placeholder="填写个数" class="flex_1" type="text" />
          <span class="fb">个</span>
        </li>
        <li>
          <div class="w25 fb t_right">总积分数</div>
          <input v-model="pointsGive.givePoints" @input="pointsGive.givePoints=formatNums(pointsGive.givePoints,2)" placeholder="0.00" class="flex_1" type="text" />
          <span class="fb">{{shopPoints.pointsName}}</span>
        </li>
      </template>
      <template v-if="pointsGive.giveType === '3'">
        <li>
          <div class="w25 fb t_right">赠送对象</div>
          <input v-if="memberList.length === 0" v-model="pointsGive.mobilePhone" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入手机号" class="flex_1" type="text" />
          <router-link v-else class="flex_1 t_right" :to="`/integral/userList?shopId=${shopId}&giveType=${pointsGive.giveType}`">
            <span class="gray_9">
              {{exclusive}} >
            </span>
          </router-link>
        </li>
        <li>
          <div class="w25 fb t_right">单个积分</div>
          <input v-model="pointsGive.singlePoints" @input="pointsGive.singlePoints=formatNums(pointsGive.singlePoints,2)" placeholder="0.00" class="flex_1" type="text" />
          <span class="fb">{{shopPoints.pointsName}}</span>
        </li>
      </template>
    </ul>
    <div class="gift_remark b_white">
      <input v-model="pointsGive.giveName" type="text" maxlength="50" class="gray_3" :placeholder="defaultGiveName" />
    </div>
    <div class="gift_btn" @click="addGivePoints">去赠送</div>

    <div class="share_mask" v-show="isShowShare" @click="isClose">
      <img src="../images/share.png" alt="">
    </div>
  </div>
</template>
<script>

import { Dialog, Toast } from "vant";
import { mapState } from "vuex";
import common from "@/assets/js/common";

export default {

  data() {
    return {
      isShowShare: false,
      shopId: "",
      shopPoints: {
        points: "",
        pointsName: "",
        failureTime: 0
      },
      defaultGiveName: "大吉大利，财源滚滚",
      pointsGive: {
        shopId: "",
        giveName: "",
        givePoints: "",
        giveCount: "",
        singlePoints: "",
        giveType: "1", // 类型 1:普通,2:拼手气,3指定人领取
        typeJsonList: [],
        mobilePhone: ""
      },
      giveResult: {},
      exclusive: "去选择",
      memberList: []
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.shopId = this.$route.query.shopId;
    const { giveType, mobilePhone, realName } = this.$route.query;
    if (mobilePhone) {
      this.exclusive = `${realName} ${mobilePhone}`;
      this.$set(this.pointsGive, "mobilePhone", mobilePhone);
    }
    if (giveType) {
      this.$set(this.pointsGive, "giveType", giveType);
    }
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getMyPoints();
    this.getPointsMemberList();
  },
  methods: {
    getMyPoints() {
      const params = {
        shopId: this.shopId,
        pageNum: 1,
        pageSize: 1
      };
      this.$store.dispatch("shop/shopPoints/getMyPointsList", params).then((data) => {
        const newData = data || {};
        const list = newData.list || [];
        if (list.length > 0) {
          this.shopPoints = list[0]; //eslint-disable-line
        }
      }).catch(() => {
      });
    },
    addGivePoints() {
      const params = Object.assign({}, this.pointsGive);
      // 类型 1:普通,2:拼手气,3指定人领取
      // 校验赠送个数
      if (params.giveType === "1" || params.giveType === "2") {
        if (!params.giveCount) {
          Toast("请输入赠送个数");
          return;
        }
        if (params.giveCount <= 0) {
          Toast("赠送个数不正确");
          return;
        }
      }
      if (params.giveType === "3") {
        if (!params.mobilePhone || !params.mobilePhone.trim() || params.mobilePhone.split(",").length === 0) {
          Toast("赠送对象不能为空");
          return;
        }
      }
      if (params.giveType === "1") {
        if (!params.singlePoints) {
          Toast("请输入单个积分");
          return;
        }
        if (params.singlePoints <= 0) {
          Toast("单个积分不正确");
          return;
        }
      }
      if (params.giveType === "2") {
        if (!params.givePoints) {
          Toast("请输入总积分数");
          return;
        }
        if (params.givePoints <= 0) {
          Toast("总积分数不正确");
          return;
        }
      }
      if (params.giveType === "3") {
        if (!params.singlePoints) {
          Toast("请输入单个积分");
          return;
        }
        if (params.singlePoints <= 0) {
          Toast("单个积分不正确");
          return;
        }
      }
      // 封装参数
      this.handleParams(params);
      // 校验单个包数量
      if (params.givePoints / params.giveCount < 0.01) {
        Toast("单个包不可低于0.01");
        return;
      }
      if (params.givePoints > this.shopPoints.points) {
        Toast("赠送总数不可大于可用数量");
        return;
      }
      let failureTimeName = `${this.shopPoints.failureTime}分钟`;
      if (this.shopPoints.failureTime >= 60) {
        const hours = Math.floor(this.shopPoints.failureTime * 100 / 60) / 100;
        failureTimeName = `${hours}小时`;
      }
      Dialog.confirm({
        title: "提示",
        message: `赠送将扣除${params.givePoints}${this.shopPoints.pointsName}，朋友${failureTimeName}内不领取，原路退回`,
        confirmButtonText: "确定赠送",
        cancelButtonText: "考虑一下"
      }).then(() => {
        this.submitGivePoints(params);
      }).catch(() => {
        // on cancel
      });
    },
    submitGivePoints(params) {
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      this.$store.dispatch("shop/shopPoints/addGivePoints", params).then((data) => {
        Toast.clear();
        if (data.code !== "0") {
          Toast(data.msg);
          return;
        }
        this.giveResult = data.data || {};
        this.initData();
      }).catch(() => {
        Toast.clear();
      });
    },
    handleParams(params) {
      let givePoints = 0;
      if (params.giveType === "1") {
        givePoints = params.giveCount * params.singlePoints;
      }
      if (params.giveType === "2") {
        givePoints = params.givePoints; //eslint-disable-line
      }
      if (params.giveType === "3") {
        const selectTypeValueList = [];
        const { mobilePhone, boId } = this.$route.query;
        if (mobilePhone && mobilePhone === params.mobilePhone) {
          selectTypeValueList.push({
            phone: mobilePhone,
            boId
          });
        } else {
          selectTypeValueList.push({
            phone: params.mobilePhone
          });
        }
        params.typeJsonList = selectTypeValueList;
        params.giveCount = selectTypeValueList.length;
        givePoints = params.giveCount * params.singlePoints;
      }
      params.givePoints = givePoints;
      params.shopId = this.shopId;
      if (!params.giveName) {
        params.giveName = this.defaultGiveName;
      }
    },
    // 初始化分享
    initData() {
      const shareImgUrl = "https://filesouthcdn.nxin.com/nxsc_1626332876367044064036967919873.JPEG";
      const param = `?shopId=${this.shopId}&giveId=${this.giveResult.id}`;
      const urlShare = `${process.env.VUE_APP_APP}vm/integral/redPacket${param}`;
      const titleShare = `${this.giveResult.giveName}`;
      const descShare = `送你一个${this.shopPoints.pointsName}包，快来抢`;
      if (common.isInWeiXin()) {
        common.initShare(titleShare, descShare, urlShare, shareImgUrl);
      }
      this.toShare();
    },
    getPointsMemberList() {
      this.$store.dispatch("member/member/getPointsMemberList", {}).then((data) => {
        this.memberList = data || {};
      }).catch(() => {
      });
    },
    isClose() {
      this.isShowShare = false;
    },
    toShare() {
      this.isShowShare = true;
    },
    switchGiveType(type) {
      this.$set(this.pointsGive, "giveType", type);
    },
    // num 输入的数字 decimal 小数位
    formatNums(nums, decimal) {
      let value = `${nums}`;
      let scale = `${decimal}`;
      if (!scale || scale <= 0) {
        scale = "0";
      }
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      if (value === "." || value === "" || value === "-") {
        return "";
      }
      const indexOf = value.lastIndexOf(".");
      // 没有小数点
      if (indexOf < 0) {
        // 没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (indexOf >= 0 && (scale === "0")) {
        value = parseInt(value, 10);
      }
      return value.toString();
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
